// Bildirim sesi tek yerden çalınır. Eski hâl `new Audio("http://gget.it/...")`
// idi: adres bizim değildi, `http://` olduğu için HTTPS sayfada tarayıcı
// engelliyordu (yani ses hiç çıkmıyordu) ve her bildirimde üçüncü tarafa
// istek gidiyordu.
const SOUND_URL = "/popsound.mp3";

let audio = null;

export function playNotificationSound() {
  try {
    if (!audio) {
      audio = new Audio(SOUND_URL);
    }

    // Üst üste gelen bildirimlerde ses başa sarılmazsa ikincisi duyulmaz.
    audio.currentTime = 0;

    const played = audio.play();

    // Tarayıcının otomatik oynatma politikası, kullanıcı sayfayla hiç
    // etkileşmediyse isteği reddeder. Yakalanmazsa konsola "Uncaught (in
    // promise)" düşer; ses duyulmaması bir hata değildir.
    if (played && typeof played.catch === "function") {
      played.catch(() => {});
    }
  } catch (error) {
    // Ses çalınamaması hiçbir akışı durdurmamalı.
  }
}

export default playNotificationSound;
